import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const quizById = createAsyncThunk(
  TYPES.QUIZ_BY_ID,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.quizById(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const quizCreate = createAsyncThunk(
  TYPES.QUIZ_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.quizCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const quizDelete = createAsyncThunk(
  TYPES.QUIZ_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.quizDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const quizAll = createAsyncThunk(
  TYPES.QUIZ_ALL,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.quizAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const quizList = createAsyncThunk(
  TYPES.QUIZ_LIST,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.quizList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const quizPublish = createAsyncThunk(
  TYPES.QUIZ_PUBLISH,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ_PUBLISH}`, 'post'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.quizPublish(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const quizCacheById = createAsyncThunk(
  TYPES.QUIZ_CACHE_BY_ID,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ_CACHE}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.quizCacheById(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const quizCacheAll = createAsyncThunk(
  TYPES.QUIZ_CACHE_ALL,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ_CACHE_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.quizCacheAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

// export const quizResetOpen = createAsyncThunk(
//   TYPES.QUIZ_RESET_OPEN,
//   async (params: PayloadCreatorParams<'/quiz_assessment/reset/open', 'get'>, { rejectWithValue }) => {
//     try {
//       const response = await api.quizResetOpen(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
//       params?.onFulfilled && params.onFulfilled(response.data)
//       return response.data
//     } catch (e) {
//       const error = toastError(e)
//       params?.onRejected && params.onRejected({ error })
//       return rejectWithValue(error)
//     } finally {
//       params?.onSettled && params.onSettled()
//     }
//   }
// )

// export const quizResetOpenAll = createAsyncThunk(
//   TYPES.QUIZ_RESET_OPEN_ALL,
//   async (params: PayloadCreatorParams<`${typeof API.QUIZ_RESET_OPEN_ALL}`, 'get'>, { rejectWithValue }) => {
//     try {
//       const response = await api.quizResetOpenAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
//       params?.onFulfilled && params.onFulfilled(response.data)
//       return response.data
//     } catch (e) {
//       const error = toastError(e)
//       params?.onRejected && params.onRejected({ error })
//       return rejectWithValue(error)
//     } finally {
//       params?.onSettled && params.onSettled()
//     }
//   }
// )

// export const quizResultOpen = createAsyncThunk(
//   TYPES.QUIZ_RESULT_OPEN,
//   async (params: PayloadCreatorParams<`${typeof API.QUIZ_RESULT_OPEN}`, 'get'>, { rejectWithValue }) => {
//     try {
//       const response = await api.quizResultOpen(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
//       params?.onFulfilled && params.onFulfilled(response.data)
//       return response.data
//     } catch (e) {
//       const error = toastError(e)
//       params?.onRejected && params.onRejected({ error })
//       return rejectWithValue(error)
//     } finally {
//       params?.onSettled && params.onSettled()
//     }
//   }
// )

// export const quizResults = createAsyncThunk(
//   TYPES.QUIZ_RESULTS,
//   async (params: PayloadCreatorParams<`${typeof API.QUIZ_RESULTS}`, 'get'>, { rejectWithValue }) => {
//     try {
//       const response = await api.quizResults(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
//       params?.onFulfilled && params.onFulfilled(response.data)
//       return response.data
//     } catch (e) {
//       const error = toastError(e)
//       params?.onRejected && params.onRejected({ error })
//       return rejectWithValue(error)
//     } finally {
//       params?.onSettled && params.onSettled()
//     }
//   }
// )

export const quizResult = createAsyncThunk(
  TYPES.QUIZ_RESULT,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ_RESULT}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.quizResult(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const quizTypes = createAsyncThunk(
  TYPES.QUIZ_TYPES,
  async (params: PayloadCreatorParams<`${typeof API.QUIZ_TYPES}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.quizTypes(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const quizByIdClear = createAction(`${TYPES.QUIZ_BY_ID}/clear`)

export const quizListClear = createAction(`${TYPES.QUIZ_LIST}/clear`)

export const quizAllClear = createAction(`${TYPES.QUIZ_ALL}/clear`)

export const quizCacheAllClear = createAction(`${TYPES.QUIZ_CACHE_ALL}/clear`)

export const quizResetOpenClear = createAction(`${TYPES.QUIZ_RESET_OPEN}/clear`)

export const quizResetOpenAllClear = createAction(`${TYPES.QUIZ_RESET_OPEN_ALL}/clear`)

export const quizResultOpenClear = createAction(`${TYPES.QUIZ_RESULT_OPEN}/clear`)

export const quizResultsClear = createAction(`${TYPES.QUIZ_RESULTS}/clear`)

export const quizTypesClear = createAction(`${TYPES.QUIZ_TYPES}/clear`)
